import {
  CreateReservationResponse,
  type TransactionLineItem,
} from 'webReservations/checkout/apiHelpers';
import { api } from '../api';

interface UpdateReservationPayload {
  date: string;
  time: string;
  guestCount: number;
  listingId: string;
  isBestAvailable: boolean;
  cancellationPolicyId: string | null;
  availabilityPrice: number;
  transactionLineItems?: TransactionLineItem[];
}

export type UpdateReservationResponse = CreateReservationResponse;

export const updateReservation = async ({
  reservationId,
  payload,
}: {
  reservationId: string;
  payload: UpdateReservationPayload;
}): Promise<UpdateReservationResponse> =>
  api.put(`/reservations/${reservationId}`, payload);
